// src/features/security/hooks/useSecurityWorkspaceMock.ts
//
// Single read seam for the security workspace route (/security/:id),
// same pattern as useCommissionWorkspaceMock/useUserWorkspaceMock.
// Looks up the base security module plus the per-module
// policy/permissions/sessions/timeline maps in data/security.mock.ts
// by id. Synchronous by design (no loading/error state) — there is no
// real request happening yet, this only becomes needed once this
// wraps a real security-detail endpoint. SecurityWorkspacePage reads
// through this hook instead of importing the mock maps directly, so
// that later swap only touches this file.

import {
  securityMock,
  securityPolicyMock,
  securityPermissionsMock,
  securitySessionsMock,
  securityTimelineMock,
} from '../data/security.mock';

export function useSecurityWorkspaceMock(id: string | undefined) {
  const module = id ? securityMock.find((candidate) => candidate.id === id) : undefined;

  return {
    module,
    policy: id ? securityPolicyMock[id] : undefined,
    permissions: id ? securityPermissionsMock[id] ?? [] : [],
    sessions: id ? securitySessionsMock[id] ?? [] : [],
    timeline: id ? securityTimelineMock[id] ?? [] : [],
  };
}
